import {
    loadAnalyticsIfConsented,
    revokeAnalyticsConsent,
    saveMetrikaPreference,
} from './analytics';

var CONSENT_KEY = 'museum-cookie-consent';
var CONSENT_COOKIE = 'museum_cookie_consent';
var SESSION_DECLINED_KEY = 'museum-cookie-declined-session';
var CONSENT_MAX_AGE = 60 * 60 * 24 * 365;

function hasConsentCookie() {
    return document.cookie.split(';').some(function (part) {
        return part.trim().indexOf(CONSENT_COOKIE + '=accepted') === 0;
    });
}

function setConsentCookie() {
    document.cookie =
        CONSENT_COOKIE + '=accepted; path=/; max-age=' + CONSENT_MAX_AGE + '; SameSite=Lax';
}

export function initCookieBanner() {
    var root = document.querySelector('[data-museum-cookie]');
    if (!root) {
        return;
    }

    if (localStorage.getItem(CONSENT_KEY) === 'accepted' || hasConsentCookie()) {
        loadAnalyticsIfConsented();
        return;
    }

    if (
        localStorage.getItem(CONSENT_KEY) === 'declined' ||
        sessionStorage.getItem(SESSION_DECLINED_KEY) === '1'
    ) {
        return;
    }

    var expandBtn = root.querySelector('[data-museum-cookie-expand]');
    var settingsBtn = root.querySelector('[data-museum-cookie-settings-open]');
    var collapseBtn = root.querySelector('[data-museum-cookie-collapse]');
    var acceptBtn = root.querySelector('[data-museum-cookie-accept]');
    var declineBtn = root.querySelector('[data-museum-cookie-decline]');
    var settingsPanel = root.querySelector('[data-museum-cookie-settings]');
    var metrikaCheckbox = root.querySelector('[data-museum-cookie-metrika]');

    function expand() {
        root.classList.remove('is-settings');
        root.classList.add('is-expanded');
        if (settingsPanel) {
            settingsPanel.hidden = true;
        }
    }

    function openSettings() {
        root.classList.remove('is-expanded');
        root.classList.add('is-settings');
        if (settingsPanel) {
            settingsPanel.hidden = false;
        }
    }

    function collapse() {
        root.classList.remove('is-expanded', 'is-settings');
        if (settingsPanel) {
            settingsPanel.hidden = true;
        }
    }

    function accept() {
        var metrikaEnabled = metrikaCheckbox ? metrikaCheckbox.checked : true;

        localStorage.setItem(CONSENT_KEY, 'accepted');
        sessionStorage.removeItem(SESSION_DECLINED_KEY);
        saveMetrikaPreference(metrikaEnabled);
        setConsentCookie();
        root.hidden = true;

        if (metrikaEnabled) {
            loadAnalyticsIfConsented();
        }
    }

    function decline() {
        revokeAnalyticsConsent();
        sessionStorage.setItem(SESSION_DECLINED_KEY, '1');
        root.hidden = true;
    }

    root.hidden = false;

    expandBtn.addEventListener('click', expand);
    settingsBtn.addEventListener('click', openSettings);
    collapseBtn.addEventListener('click', collapse);
    acceptBtn.addEventListener('click', accept);
    declineBtn.addEventListener('click', decline);
}
